// localStoragePlugin.js
import { SET_STUDY_SET_FILTERS, SET_STUDY_SET_IS_FILTER } from "@/store/constants";

export const localStoragePlugin = store => {
  // Subscribe to mutations
  store.subscribe((mutation, state) => {
    if (mutation.type === `studysets/${SET_STUDY_SET_FILTERS}`) {
      localStorage.setItem('studysets.filters', JSON.stringify(state.studysets.filters));
    }

    if (mutation.type === `studysets/${SET_STUDY_SET_IS_FILTER}`) {
      localStorage.setItem('studysets.isFilter', JSON.stringify(state.studysets.isFilter));
    }
  });
  // Try to retrieve the properties from local storage when the store is created
  const storedStudySetFilters = localStorage.getItem('studysets.filters');
  if (storedStudySetFilters) {
    store.commit(`studysets/${SET_STUDY_SET_FILTERS}`, JSON.parse(storedStudySetFilters));
  }

  const storedIsStudySetFilter = localStorage.getItem('studysets.isFilter');
  if (storedIsStudySetFilter) {
    store.commit(`studysets/${SET_STUDY_SET_IS_FILTER}`, JSON.parse(storedIsStudySetFilter));
  }
};
